import { render, staticRenderFns } from "./WhitePhoneNumbers.vue?vue&type=template&id=7ff80381&scoped=true"
import script from "./WhitePhoneNumbers.vue?vue&type=script&lang=js"
export * from "./WhitePhoneNumbers.vue?vue&type=script&lang=js"
import style0 from "./WhitePhoneNumbers.vue?vue&type=style&index=0&id=7ff80381&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff80381",
  null
  
)

export default component.exports